import React, { useState } from 'react'
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../../../core/common/textFields/TextField';
import { svgIcons } from '../../../../../../style/fonts/SvgIcons';
import { DatePicker, TimePicker, TimePickerProps } from 'antd';
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import DateField from '../../../../../../core/common/textFields/DateField';
import { getMultiSelectLabels, getNestedOptionsMapping, getOptionsMapping, getTargetOptions } from '../../../../LeadsProspect/InfluencerOptions';


type InfluencerOption = {
    id: number;
    value: string;
};

const GeneralTabCol1 = ({ isReadOnly, formik, initialValues, leadsInquiryLookups, getdefaultLookups }: any) => {

    const [selectedInquiryDate, setSelectedInquiryDate] = useState<Date | null>(null);
    const [selectedQualifyDate, setSelectedQualifyDate] = useState<Date | null>(null);
    const [selectedItems, setSelectedItems] = useState<{ id: string; title: string }[]>([]);
    const [selectedSaleDate, setSelectedSaleDate] = useState<Date | null>(null);
    const [selectedDownPayDate, setSelectedDownPayDate] = useState<Date | null>(null);

    dayjs.extend(customParseFormat);
    const onChangeStart: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik.setFieldValue('saleTime', formattedTime);
    };
    const onChangeDownPaymentTime: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik.setFieldValue('downPaymentTime', formattedTime);
    };
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    const handleInquiryAptDateChange = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('inquiryDate', date ? date.format('YYYY-MM-DD') : null);
    };
    const handleQualifyAptDateChange = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('qualifyDate', date ? date.format('YYYY-MM-DD') : null);
    };
    const handleSaleDateChange = (date: Dayjs | null) => {
        // setSelectedSaleDate(date);
        formik.setFieldValue('saleDate', date)
    };
    const handleDownPayDateChange = (date: Dayjs | null) => {
        // setSelectedDownPayDate(date);
        formik.setFieldValue('downPaymentDate', date)
    };
    const selectValues = formik.values?.lst_Influencer
        ? formik.values.lst_Influencer
            .filter((influencer: { id: number; value: string }) => influencer.id !== 0 && influencer.value !== '')
            .map((influencer: { id: number; value: string }) => ({
                value: influencer.id,
                label: influencer.value,
            }))
        : [];

    const handleChange = (newValue: any) => {
        // Convert newValue to the desired format
        const updatedValues: InfluencerOption[] = newValue.map((option: { value: any; label: any }) => ({
            id: option.value,
            value: option.label
        }));

        // Set the updated values in Formik
        formik.setFieldValue('lst_Influencer', updatedValues);

        // Update selected items state
        setSelectedItems(updatedValues.map(item => ({
            id: item.id.toString(),
            title: item.value
        })));
    };

    //Field based Influencer
    interface Item {
        id: number;
        label: string;
    }
    interface SelectedNestedItems {
        [key: string]: Item[];
    }

    // Update the type of selectedItems to match the structure
    const [selectedNestedItems, setSelectedNestedItems] = useState<SelectedNestedItems>({}); // Define the type here
    const [matchedLabels, setMatchedLabels] = useState<string[]>([]);

    type InfluencerOption = {
        id: number;
        value: string;
    };

    const multiSelectLabels = getMultiSelectLabels();
    const optionsMapping = getdefaultLookups ? getOptionsMapping({ getdefaultLookups }) : {};
    const nestedOptionsMapping = getdefaultLookups ? getNestedOptionsMapping({ getdefaultLookups }) : {};

    const targetOptions = getTargetOptions();

    const titleToFormikFieldName = (title: string) => {
        return 'lst_' + title
            .replace(/ /g, '') // Remove spaces
    };

    const handleSelectChange = (title: string) => (selectedOptions: any) => {
        const fieldName = titleToFormikFieldName(title);

        // Convert selectedOptions to the format Formik expects
        const values = selectedOptions.map((option: any) => ({
            id: option.value,
            name: option.label,
        }));

        formik.setFieldValue(fieldName, values);
    };
    const matchLabels = () => {
        const labels: Set<string> = new Set();
        Object.keys(selectedNestedItems).forEach((key) => {
            const selectedItems = selectedNestedItems[key];
            const selectedLabels = selectedItems.map(item => item.label);

            // Find the matching labels that we are matching with the target options which are predefined // for dynamic fields
            const matchedLabels = selectedLabels.filter(label => targetOptions.includes(label));

            matchedLabels.forEach(label => labels.add(label));
        });
        setMatchedLabels(Array.from(labels));
    };

    const handleNestedSelectChange = (label: string) => (selectedOptions: any) => {
        const camelCaseLabel = label
            .split(' ')
            .map((word, index) => {
                if (word.length === 1 || word.toUpperCase() === word) {
                    return word.toLowerCase();
                }
                return index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join('');

        const formattedOptions = (selectedOptions || []).map((item: any) => ({
            id: parseInt(item.value),
            label: item.label,
        }));

        formik.setFieldValue(camelCaseLabel, {
            id: formattedOptions.map((item: { id: any }) => item.id),
            name: formattedOptions.map((item: { label: any }) => item.label),
        });
    };

    // const handleChange = (newValue: any) => {
    //     // Convert newValue to the desired format
    //     const updatedValues: InfluencerOption[] = newValue.map((option: { value: any; label: any }) => ({
    //         id: option.value,
    //         value: option.label
    //     }));

    //     // Set the updated values in Formik
    //     formik.setFieldValue('lst_Influencer', updatedValues);

    //     // Update selected items state
    //     setSelectedItems(updatedValues.map(item => ({
    //         id: item.id.toString(),
    //         title: item.value
    //     })));
    // };

    return (
        <>
            <div className='card'>
                <div className='card-body'>
                    <h5 className='mb-2'>
                        Rating & Priority
                    </h5>
                    <div className="col-md-12">
                        <label className='input-label'>Priority Code  </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_PriorityCode?.map((option: any) => ({
                                label: option?.value,
                                value: option?.id
                            }))}
                            value={
                                formik.values?.lst_PriorityCode?.id
                                    ? {
                                        value: formik.values?.lst_PriorityCode?.id,
                                        label: formik.values?.lst_PriorityCode?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_PriorityCode.id', selectedOption.value);
                                formik.setFieldValue('lst_PriorityCode.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className='input-label'>Rating  </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={getdefaultLookups?.result?.Lst_Rating?.map((option: any) => ({
                                label: option?.value,
                                value: option?.id
                            }))}
                            value={
                                formik.values?.lst_Rating?.id
                                    ? {
                                        value: formik.values?.lst_Rating?.id,
                                        label: formik.values?.lst_Rating?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_Rating.id', selectedOption.value);
                                formik.setFieldValue('lst_Rating.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className='input-label'>Evaluate Fit  </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={getdefaultLookups?.result?.Lst_EvaluateFit?.map((option: any) => ({
                                label: option?.value,
                                value: option?.id
                            }))}
                            value={
                                formik.values?.lst_EvaluateFit?.id
                                    ? {
                                        value: formik.values?.lst_EvaluateFit?.id,
                                        label: formik.values?.lst_EvaluateFit?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_EvaluateFit.id', selectedOption.value);
                                formik.setFieldValue('lst_EvaluateFit.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className='input-label'>Confirm Interest  </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={getdefaultLookups?.result?.Lst_ConfirmInterest?.map((option: any) => ({
                                label: option?.value,
                                value: option?.id
                            }))}
                            value={
                                formik.values?.lst_ConfirmInterest?.id
                                    ? {
                                        value: formik.values?.lst_ConfirmInterest?.id,
                                        label: formik.values?.lst_ConfirmInterest?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_ConfirmInterest.id', selectedOption.value);
                                formik.setFieldValue('lst_ConfirmInterest.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="col-md-12">
                            <label className="input-label ">
                                Inquiry Date <span className="text-danger">*</span>
                            </label>
                            <div className="form-wrap icon-form">
                                <span className="form-icon">
                                    <i className="ti ti-calendar-check" />
                                </span>
                                <DatePicker
                                    className="form-control datetimepicker deals-details "
                                    // selected={selectedFreshAptmentDate}
                                    onChange={handleInquiryAptDateChange}
                                    value={formik.values?.inquiryDate ? dayjs(formik.values?.inquiryDate, 'YYYY-MM-DD') : null}
                                    format="MMM-DD-YYYY"
                                    />
                            </div>
                        </div>
                        {/* <div className="col-md-6">
                            <label className="input-label">
                                Time <span className="text-danger">*</span>
                            </label>
                            <TimePicker
                                placeholder="Select Time"
                                className="form-control datetimepicker-time"
                                onChange={onChangeStart}
                                defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
                                format="h:mm A"
                                use12Hours
                                disabled={isReadOnly}
                            />
                        </div> */}
                    </div>
                    {/* <div className='d-flex'> */}
                    <div className="col-md-12">
                        <label className="input-label">
                            Qualify Date <span className="text-danger">*</span>
                        </label>
                        <div className="form-wrap icon-form">
                            <span className="form-icon">
                                <i className="ti ti-calendar-check" />
                            </span>
                            <DatePicker
                                className="form-control datetimepicker deals-details "
                                // selected={selectedFreshAptmentDate}
                                onChange={handleQualifyAptDateChange}
                                value={formik.values?.qualifyDate ? dayjs(formik.values?.qualifyDate, 'YYYY-MM-DD') : null}
                                format="MMM-DD-YYYY"
                                />
                        </div>
                    </div>
                    {/* <div className="col-md-6">
                            <label className="input-label">
                                Time
                            </label>
                            <TimePicker
                                placeholder="Select Time"
                                className="form-control datetimepicker-time"
                                onChange={onChangeStart}
                                defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
                                format="h:mm A"
                                use12Hours
                                disabled={isReadOnly}
                            />
                        </div> */}
                    {/* </div> */}

                </div>
            </div>
            <div className='card'>
                <div className='card-body'>
                    <h5 className='mb-2'>
                        General
                    </h5>
                    <div className='row'>
                        <div className="col-md-12">
                            <label className='input-label'>Subject <span className='text-danger'>*</span> </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={getdefaultLookups?.result?.Lst_Subject?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                                value={
                                    formik.values?.lst_Subject?.id
                                        ? {
                                            value: formik.values?.lst_Subject?.id,
                                            label: formik.values?.lst_Subject?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_Subject.id', selectedOption.value);
                                    formik.setFieldValue('lst_Subject.value', selectedOption.label);
                                }}
                            />
                        </div>
                        <div className="col-md-12">
                            <label className='input-label'>Method of Inquiry <span className='text-danger'>*</span></label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={getdefaultLookups?.result?.Lst_MethodOfInquiry
                                    ?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                value={
                                    formik.values?.lst_MethodOfInquiry?.id
                                        ? {
                                            value: formik.values?.lst_MethodOfInquiry?.id,
                                            label: formik.values?.lst_MethodOfInquiry?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_MethodOfInquiry.id', selectedOption.value);
                                    formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                                }}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Lead Source Notes"
                                type="text"
                                {...formik.getFieldProps("leadSourceNotes")}
                                disabled
                                icon={svgIcons.LockIcon}

                            />
                        </div>
                        <div className="col-md-12">
                            <label className='input-label'>Lead Source code </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={getdefaultLookups?.result?.Lst_LeadSourceCodes
                                    ?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                value={
                                    formik.values?.lst_LeadSourceCode
                                        ?.id
                                        ? {
                                            value: formik.values?.lst_LeadSourceCode?.id,
                                            label: formik.values?.lst_LeadSourceCode?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_LeadSourceCode.id', selectedOption.value);
                                    formik.setFieldValue('lst_LeadSourceCode.value', selectedOption.label);
                                }}
                            />
                        </div>
                        <div className="col-md-12">
                            <div className="form-wrap">
                                <label className="input-label">Influencer</label>
                                <Select
                                    isMulti={true}
                                    styles={customStyles}
                                    className="select multi-select"
                                    options={getdefaultLookups?.result?.Lst_Influencer?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    })) || []}
                                    value={
                                        selectValues
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-wrap">
                                <label className="input-label">Hide & Show Buttons</label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={leadsInquiryLookups?.result?.Lst_HideAndShow
                                        ?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id
                                        }))}
                                    value={
                                        formik.values?.lst_HideAndShow
                                            ?.id
                                            ? {
                                                value: formik.values?.lst_HideAndShow?.id,
                                                label: formik.values?.lst_HideAndShow?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_HideAndShow.id', selectedOption.value);
                                        formik.setFieldValue('lst_HideAndShow.value', selectedOption.label);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className='card'>
                <div className='card-body'>
                    {selectedItems.map((item) => {
                        // Destructure id and title
                        const { id, title } = item;

                        // Check if the ID is in the set of multi-select labels
                        const isMultiSelect = multiSelectLabels.has(id.toString());

                        const titleToFieldName = (title: string) => {
                            return 'Lst_' + title
                                .replace(/ /g, '') // Remove spaces
                        };

                        const fieldName = titleToFieldName(title);
                        const formikFieldName = titleToFormikFieldName(title); // Convert title to Formik field name
                        const formikValue = formik.values[formikFieldName] || [];
                        const mappedValue = formik.values[formikValue]?.map((option: any) => ({
                            value: option.id.toString(),
                            label: option.name,
                        }));


                        if (isMultiSelect) {
                            // Directly use the title for rendering
                            return (
                                <div key={id} className='form-wrap'>
                                    <label className='input-label'>{title}</label>
                                    <Select
                                        isMulti
                                        name={title} // Use title directly
                                        className="select multi-select"
                                        options={optionsMapping[fieldName] || []}
                                        value={mappedValue} // Ensure this matches the format
                                        onChange={handleSelectChange(title)}
                                    />
                                </div>
                            );
                        }

                        return null;
                    })}

                    {matchedLabels.map(label => {
                        const camelCaseLabel = label
                            .split(' ')
                            .map((word, index) => {
                                if (word.length === 1 || word.toUpperCase() === word) {
                                    // Convert single letters or all-uppercase words to lowercase
                                    return word.toLowerCase();
                                }
                                return index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                            })
                            .join('');

                        const value = formik.values[camelCaseLabel as keyof typeof initialValues] as { id: number[]; name: string[] } || { id: [], name: [] };

                        return (
                            <div key={label} className='form-wrap'>
                                <label className='input-label'>{label}</label>
                                <Select
                                    isMulti
                                    name={camelCaseLabel}
                                    className="select multi-select"
                                    options={nestedOptionsMapping[label] || []}
                                    value={value.name.map((name: string, index: number) => ({
                                        value: value.id[index].toString(),
                                        label: name
                                    }))}
                                    onChange={handleNestedSelectChange(label)}
                                />
                            </div>
                        );
                    })}
                </div>
            </div> */}
            <div className='card'>
                <div className='card-body'>
                    <h5 className='mb-0'>
                        Design Associate
                    </h5>
                    <div className="col-md-12">
                        <div className="form-wrap">
                            <label className="input-label">DA Support</label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={leadsInquiryLookups?.result?.Lst_DaSupport
                                    ?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                value={
                                    formik.values?.lst_DaSupport
                                        ?.id
                                        ? {
                                            value: formik.values?.lst_DaSupport?.id,
                                            label: formik.values?.lst_DaSupport?.value || '',
                                        }
                                        : null
                                }
                                isDisabled={isReadOnly}
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_DaSupport.id', selectedOption.value);
                                    formik.setFieldValue('lst_DaSupport.value', selectedOption.label);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='card'>
                <div className='card-body'>
                    <h5>
                        Sales and Closing
                    </h5>
                    <div className="col-md-12">
                        <label className='input-label'>Sale Status </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_SaleStatus
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_SaleStatus?.id
                                    ? {
                                        value: formik.values?.lst_SaleStatus?.id,
                                        label: formik.values?.lst_SaleStatus?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_SaleStatus.id', selectedOption.value);
                                formik.setFieldValue('lst_SaleStatus.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <>
                        <TextField
                            label="Sale Amount"
                            type="number"
                            {...formik.getFieldProps("saleAmount")}
                            disabled={isReadOnly}
                            icon2={svgIcons.dollarIcon}
                            required
                        />
                    </>
                    <div className='d-flex gap-2'>
                        <div className="col-md-6">
                            <label className='input-label'>Sale Date</label>
                        <div className="form-wrap icon-form">
                            <span className="form-icon">
                                <i className="ti ti-calendar-check" />
                            </span>
                            <DatePicker
                                className="form-control datetimepicker deals-details "
                                onChange={handleSaleDateChange}
                                disabled={isReadOnly}
                                value={formik.values?.saleDate ? dayjs(formik.values?.saleDate, 'YYYY-MM-DD') : null}
                                format="MMM-DD-YYYY"

                            />
                        </div>
                        </div>
                        <div className="col-md-6">
                            <label className="input-label">
                                Time
                            </label>
                            <TimePicker
                                placeholder="Select Time"
                                className="form-control datetimepicker-time"
                                onChange={onChangeStart}
                                value={formik.values?.saleTime && dayjs(formik.values.saleTime, "h:mm A").isValid()
                                    ? dayjs(formik.values.saleTime, "h:mm A")
                                    : null}
                                format="h:mm A"
                                use12Hours
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                    <>
                        <TextField
                            label="Down Payment Amount"
                            type="number"
                            {...formik.getFieldProps("downPaymentAmount")}
                            disabled={isReadOnly}
                            required
                            icon2={svgIcons.dollarIcon}

                        />
                    </>
                    <div className="col-md-12">
                        <label className='input-label'>Down Payment Type </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_DownPaymentPaymentType
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_DownPaymentPaymentType?.id
                                    ? {
                                        value: formik.values?.lst_DownPaymentPaymentType?.id,
                                        label: formik.values?.lst_DownPaymentPaymentType?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_DownPaymentPaymentType.id', selectedOption.value);
                                formik.setFieldValue('lst_DownPaymentPaymentType.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="col-md-6">
                            <label className='input-label'>Down Payment Date </label>
                            <div className="form-wrap icon-form">
                            <span className="form-icon">
                                <i className="ti ti-calendar-check" />
                            </span>
                            <DatePicker
                                className="form-control datetimepicker deals-details "
                                onChange={handleDownPayDateChange}
                                disabled={isReadOnly}
                                value={formik.values?.downPaymentDate ? dayjs(formik.values?.downPaymentDate, 'YYYY-MM-DD') : null}
                                format="MMM-DD-YYYY"

                            />
                        </div>
                        </div>
                        <div className="col-md-6">
                            <label className="input-label">
                                Time
                            </label>
                            <TimePicker
                                placeholder="Select Time"
                                className="form-control datetimepicker-time"
                                onChange={onChangeDownPaymentTime}
                                value={formik.values?.downPaymentTime && dayjs(formik.values.downPaymentTime, "h:mm A").isValid()
                                    ? dayjs(formik.values.downPaymentTime, "h:mm A")
                                    : null}
                                format="h:mm A"
                                use12Hours
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <label className='input-label'>Ceremony Location Code </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_SaleCeremonyLocationCode
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_SaleCeremonyLocationCode?.id
                                    ? {
                                        value: formik.values?.lst_SaleCeremonyLocationCode?.id,
                                        label: formik.values?.lst_SaleCeremonyLocationCode?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_SaleCeremonyLocationCode.id', selectedOption.value);
                                formik.setFieldValue('lst_SaleCeremonyLocationCode.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className='input-label'>Sale Confirmed </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_SaleConfirmed
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_SaleConfirmed?.id
                                    ? {
                                        value: formik.values?.lst_SaleConfirmed?.id,
                                        label: formik.values?.lst_SaleConfirmed?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_SaleConfirmed.id', selectedOption.value);
                                formik.setFieldValue('lst_SaleConfirmed.value', selectedOption.label);
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default GeneralTabCol1